import { useState, useEffect } from 'react'

// Full transformed history for one cycle cell (/api/cycle-series?cell=…),
// fetched lazily when a detail sheet's chart opens. Session-cached per cell.
// Returns { data: { key, grain, window, isYoY, series: [{p,v},…] } | null,
// loading } — null data means "no full history"; the sheet falls back to the
// 24-point Spark it already has.
const cache = new Map()

export function useCycleSeries(cellKey) {
  const [data, setData] = useState(() => cache.get(cellKey) ?? null)
  const [loading, setLoading] = useState(() => !!cellKey && !cache.has(cellKey))

  useEffect(() => {
    if (!cellKey || cache.has(cellKey)) { setData(cache.get(cellKey) ?? null); setLoading(false); return undefined }
    let cancelled = false
    setLoading(true)
    fetch(`/api/cycle-series?cell=${encodeURIComponent(cellKey)}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        const ok = d?.series?.length > 1 ? d : null
        cache.set(cellKey, ok)
        if (!cancelled) { setData(ok); setLoading(false) }
      })
      .catch(() => { if (!cancelled) { setData(null); setLoading(false) } })
    return () => { cancelled = true }
  }, [cellKey])

  return { data, loading }
}
